import React from 'react';
import styled from 'styled-components';
import { fontSize, colours, spacing } from '../../../theme';

import Tiles from './tiles';

import { JOBS_TITLE } from '../../../constants/titles';

const SubHeader = styled.div`
  text-transform: uppercase;
  font-size: ${fontSize.tiny};
  font-weight: 600;
  color: ${colours.black};
  text-align: center;
  padding: ${spacing.tiny};
  background-color: ${colours.white};
`;

const Jobs = ({ employersRecord, schemesRecord, active, setActive, modalIsOpen, setModalIsOpen, setTitle }) => {

  setTitle(JOBS_TITLE);

  if (employersRecord !== null && schemesRecord !== null) {
    setActive(true);
  }

  return (
    <div>
      <SubHeader>Employers who meet our criteria</SubHeader>
      {active && (
        <Tiles
          employersRecord={employersRecord}
          schemesRecord={schemesRecord}
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
        />
      )}
    </div>
  );
};

export default Jobs;
